import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CFormCheck,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react'
import 'src/views/container/cms/content.scss'
import '../../../scss/style.scss'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import DefaultSwimlaneManual from './defaultSwimlaneManual'
import DefaultSwimlaneDynamic from './defaultSwimlaneDynamic'
import { GlobalContext } from 'src/views/context/GlobalState'
import { capitalize, isEmpty } from 'lodash'
import { getThumbnail } from 'src/views/utils/helper'
import PreviewDetails from 'src/views/container/AssetManager/PreviewDetails'
import moment from 'moment'
import DefaultSwimlanePreview from './defaultSwimlanePreview'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import {
  ARTIST_LIST_API,
  META_DATA_URL,
  VENUE_LIST_API,
  SUBSCRIPTION_API,
} from 'src/views/utils/urls'
import Loading from 'react-fullscreen-loading'
import DefaultDynamicPreview from './defaultDynamicPreview'
import DesignSettingOverlay from '../designSettingOverlay'
import PaintBrushIcon from '../../../assets/paint-brush-icon.svg'

const DefaultSwimlaneModal = ({
  componentData,
  modifyData,
  modalSpecificData,
  onCancel,
  isAdvancedEditAllowed,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const [swimlaneName, setSwimlaneName] = useState('')
  const [autoGenrate, setAutoGenrate] = useState(false)
  const [previewContent, setPreviewContent] = useState({})
  // const [swimlanePreviewContents, setSwimlanePreviewContents] = useState([])
  const [basicInfo, setBasicInfo] = useState([])
  const [selectedContents, setSelectedContents] = useState([])
  const [autoPayload, setAutoPayload] = useState([])
  const [playlistPreview, setPlaylistPreview] = useState(false)
  const [orderBy, setOrderBy] = useState('modified_date')
  const [reverse, setReverse] = useState(false)
  const { setLoader, loader } = useContext(AppContext)
  const [styleConfig, setStyleConfig] = useState({})
  const [designSettingOptions, setDesignSettingOptions] = useState([])

  const [{ data: categories, loading: categoriesLoading }] = useAxios({
    url: `${META_DATA_URL}/system`,
    method: 'get',
  })

  const [{ data: subscriptionList, loading: subscriptionListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=normal',
    method: 'get',
  })

  const [{ data: ppvList, loading: ppvListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=ppv',
    method: 'get',
  })

  const [{ data: artist, loading: artistLoading }] = useAxios({
    url: ARTIST_LIST_API,
    method: 'get',
  })

  const [{ data: venue, loading: venueLoading }] = useAxios({
    url: VENUE_LIST_API,
    method: 'get',
  })

  const [{ data: customMetadata, loading: customMetadataLoading }] = useAxios({
    url: `${META_DATA_URL}/custom/content`,
    method: 'get',
  })

  useEffect(() => {
    setLoader(
      customMetadataLoading ||
        categoriesLoading ||
        artistLoading ||
        venueLoading ||
        subscriptionListLoading ||
        ppvListLoading,
    )
  }, [
    customMetadataLoading,
    categoriesLoading,
    artistLoading,
    venueLoading,
    subscriptionListLoading,
    ppvListLoading,
  ])

  useEffect(() => {
    setSwimlaneName(componentData?.data?.name)
    setAutoGenrate(componentData?.data?.type === 'DYNAMIC')
    setSelectedContents(componentData?.data?.content_data)
    setAutoPayload(componentData?.data?.auto_payload)
    setOrderBy(componentData?.data?.order_by)
    setReverse(componentData?.data?.reverse)
    if (!isEmpty(componentData?.data?.content_data)) {
      setPlaylistPreview(true)
    }
    if (componentData?.data?.style_config) {
      setStyleConfig(componentData?.data?.style_config)
    }
  }, [])

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Title',
        value: previewContent.title,
      },
      {
        property: 'Description',
        value: previewContent?.description,
      },
      {
        property: 'Content Type',
        value: previewContent?.video_type,
      },
      {
        property: 'File Type',
        value: previewContent?.asset_type,
      },

      {
        property: 'Category',
        value: !isEmpty(previewContent?.category)
          ? [...previewContent?.category].map((info) => info.name).toString()
          : '',
      },
      { property: 'Status', value: capitalize(String(previewContent?.publish_policy)) },
      {
        property: 'Monetization',
        value:
          previewContent?.active_subscription?.length > 0 ||
          previewContent?.active_ppv_subscription?.length > 0
            ? 'Paid'
            : 'Free',
      },
      {
        property: 'Publish Time',
        value: moment(previewContent?.publish_time).format('DD MMM YYYY'),
      },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [previewContent])

  const handleSave = () => {
    let elementObj = {
      name: swimlaneName,
      type: autoGenrate ? 'DYNAMIC' : 'STATIC',
      content_data: autoGenrate ? [] : selectedContents,
      auto_payload: autoGenrate ? autoPayload : [],
      order_by: orderBy,
      reverse: reverse,
      style_config: styleConfig,
    }
    modifyData(componentData.id, elementObj)
  }

  const handleOrderBy = (value) => {
    let valueArr = value.split('-')
    setOrderBy(valueArr[0])
    setReverse(valueArr[1] === 'desc')
  }

  const getStyleConfig = (keyArr = []) => {
    if (!componentData?.data?.style_config) {
      return []
    }
    let stylesArr = []
    for (let i = 0; i < keyArr.length; i++) {
      const key = keyArr[i]
      let styleObj = componentData?.data?.style_config[key]
      stylesArr.push(styleObj)
    }
    return stylesArr
  }

  const handleStyleSave = (data) => {
    let tempStyleObj = styleConfig
    for (let i = 0; i < data.length; i++) {
      const ele = data[i]
      tempStyleObj[ele.key] = ele
    }
    setStyleConfig({ ...tempStyleObj })
    setDesignSettingOptions([])
  }

  return (
    <CModal size="xl" className="swimlane-content-modal" visible={true}>
      {!isEmpty(designSettingOptions) && (
        <DesignSettingOverlay
          width={'25%'}
          options={designSettingOptions}
          onCancel={() => setDesignSettingOptions([])}
          handleSave={(data) => handleStyleSave(data)}
        />
      )}
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      {!isEmpty(previewContent) && (
        <PreviewDetails
          onClose={() => setPreviewContent({})}
          cardImage={getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            previewContent?.thumbnail,
          )}
          headline="Content Preview"
          subHeadline="Detailed information about the selected Content"
          basicInfo={basicInfo}
          resolutions={{}}
        />
      )}
      <CModalHeader style={{}} className="d-flex flex-column align-items-start mt-1 px-5">
        <div className="d-flex justify-content-center w-100 mb-2">
          <p style={{ fontSize: '1.2rem' }} className="mb-0 mx-2">
            <b style={{ fontWeight: '500', color: '#191818' }}>Content Swimlane Editor</b>
          </p>
          {componentData?.data?.style_config && isAdvancedEditAllowed && (
            <div
              className={`h-[30px] w-[30px] d-flex justify-content-center align-items-center rounded-full overflow-hidden "`}
            >
              <img
                src={PaintBrushIcon}
                alt="PaintBrushIcon"
                className="cursor-pointer w-full h-full"
                onClick={() => {
                  setDesignSettingOptions(
                    getStyleConfig(['component_background', 'heading', 'card_style']),
                  )
                }}
              />
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-between">
          <div className="w-50 mt-2">
            <h6 style={{ fontSize: '13px', color: '#191919' }} className="">
              HEADING
            </h6>
            <CustomDescriptionBox
              limit={100}
              rows={1}
              value={swimlaneName}
              onChange={(value) => setSwimlaneName(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          {playlistPreview && autoGenrate && (
            <div className="w-25 mt-2">
              <h6 style={{ fontSize: '13px', color: '#191919' }} className="">
                Order By
              </h6>
              <CFormSelect
                value={`${orderBy}-${!reverse ? 'aesc' : 'desc'}`}
                onChange={(e) => {
                  handleOrderBy(e.target.value)
                }}
              >
                <option value={'modified_date-desc'}>Modified Date Descending</option>
                <option value={'modified_date-aesc'}>Modified Date Ascending</option>
                <option value={'created_date-desc'}>Created Date Descending</option>
                <option value={'created_date-aesc'}>Created Date Ascending</option>
                <option value={'release_time-desc'}>Release Date Descending</option>
                <option value={'release_time-aesc'}>Release Date Ascending</option>
                <option value={'title-aesc'}>Title {`(A to Z)`}</option>
                <option value={'title-desc'}>Title {`(Z to A)`}</option>
                <option value={'random-aesc'}>Random</option>
              </CFormSelect>
            </div>
          )}
        </div>
      </CModalHeader>
      <CModalBody className="  d-flex flex-column justify-content-between px-5 ">
        {playlistPreview ? (
          autoGenrate ? (
            <DefaultDynamicPreview
              filterData={{
                system_defined: autoPayload.filter((info) => info.type === 'system_defined'),
                custom_defined: autoPayload.filter((info) => info.type === 'custom_defined'),
                video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
              }}
              orderBy={orderBy}
              reverse={reverse}
            />
          ) : (
            <DefaultSwimlanePreview
              filterData={{ content_ids: selectedContents }}
              setContentData={(arr) => {
                setSelectedContents(arr.map((ele) => ele.content_id))
              }}
              goBackToSelection={() => setPlaylistPreview(false)}
            />
          )
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h5
                  style={{
                    color: '#191818',
                    fontSize: '30px',
                    fontWeight: '700',
                    marginBlockEnd: '0',
                  }}
                >
                  {autoGenrate ? 'FILTER CONTENTS' : 'Select Contents'}
                </h5>
                <span style={{ fontSize: '.9vw', fontWeight: '500' }}>
                  {autoGenrate
                    ? 'Define a filtering criteria to create a Dynamic Playlist from Content Library'
                    : 'Select a list of Contents to create a Static Playlist from Content Library'}
                </span>
              </div>
              <div
                className="d-flex justify-content-center align-items-center rounded-1 overflow-hidden mt-1"
                style={{ border: '0.5px solid #707070' }}
              >
                <CFormCheck
                  className="playlist-generation-cformcheck"
                  type="radio"
                  id="flexRadioDefault1"
                  label="Manually Generate"
                  value="manual"
                  checked={!autoGenrate}
                  onChange={() => setAutoGenrate(!autoGenrate)}
                  disabled={false}
                />
                <CFormCheck
                  className="playlist-generation-cformcheck"
                  type="radio"
                  id="flexRadioDefault2"
                  label="Auto Generate"
                  value="auto"
                  checked={autoGenrate}
                  onChange={() => setAutoGenrate(!autoGenrate)}
                  disabled={false}
                />
              </div>
            </div>
            {autoGenrate ? (
              <DefaultSwimlaneDynamic
                payload={autoPayload}
                setPayload={setAutoPayload}
                customMetadataMaster={customMetadata?.data?.filter(
                  (info) => info.status && info.type !== 'text',
                )}
                categoryMasterData={categories?.data?.filter(
                  (info) => info.status && info.type === 'category',
                )}
                subCategoryMasterData={categories?.data?.filter(
                  (info) => info.status && info.type === 'sub_category',
                )}
                subscriptionMasterData={subscriptionList?.data?.filter((info) => info.status)}
                ppvMasterData={ppvList?.data?.filter((info) => info.status)}
                artistData={artist?.data?.filter((info) => info.status)}
              />
            ) : (
              <DefaultSwimlaneManual
                selectedContents={selectedContents}
                setSelectedContents={setSelectedContents}
                setPreviewContent={setPreviewContent}
                setSwimlanePreviewContents={(arr) => {}}
                categoryMasterData={categories?.data?.filter(
                  (info) => info.status && info.type === 'category',
                )}
                subCategoryMasterData={categories?.data?.filter(
                  (info) => info.status && info.type === 'sub_category',
                )}
                subscriptionMasterData={subscriptionList?.data?.filter((info) => info.status)}
                ppvMasterData={ppvList?.data?.filter((info) => info.status)}
                artistData={artist?.data?.filter((info) => info.status)}
              />
            )}
          </>
        )}
      </CModalBody>
      <CModalFooter style={{ border: 'none' }} className=" px-5">
        <CButton
          className=""
          style={{
            color: '#3a3838',
            backgroundColor: 'white',
            marginRight: '2rem',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={onCancel}
        >
          Cancel
        </CButton>
        <CButton
          color="info"
          className="text-white"
          style={{
            color: 'white',
            backgroundColor: '#20211c',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={playlistPreview ? handleSave : () => setPlaylistPreview(true)}
        >
          {playlistPreview ? 'Save' : 'Preview'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default DefaultSwimlaneModal
